// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/imageslider.scss
// module id = 71
// module chunks = 0